export const TENANT_PUBLIC_INFO = {
  AT: { code: "AT", name: "Austria", locale: "de-AT" },
  BA: { code: "BA", name: "Bosnia and Herzegovina", locale: "bs-BA" },
  BE: { code: "BE", name: "Belgium", locale: "nl-BE" },
  BG: { code: "BG", name: "Bulgaria", locale: "bg-BG" },
  CH: { code: "CH", name: "Switzerland", locale: "de-CH" },
  CZ: { code: "CZ", name: "Czech Republic", locale: "cs-CZ" },
  DE: { code: "DE", name: "Germany", locale: "de-DE" },
  DK: { code: "DK", name: "Denmark", locale: "da-DK" },
  EE: { code: "EE", name: "Estonia", locale: "et-EE" },
  ES: { code: "ES", name: "Spain", locale: "es-ES" },
  FI: { code: "FI", name: "Finland", locale: "fi-FI" },
  FR: { code: "FR", name: "France", locale: "fr-FR" },
  HR: { code: "HR", name: "Croatia", locale: "hr-HR" },
  HU: { code: "HU", name: "Hungary", locale: "hu-HU" },
  IE: { code: "IE", name: "Ireland", locale: "en-IE" },
  IT: { code: "IT", name: "Italy", locale: "it-IT" },
  LT: { code: "LT", name: "Lithuania", locale: "lt-LT" },
  LV: { code: "LV", name: "Latvia", locale: "lv-LV" },
  NL: { code: "NL", name: "Netherlands", locale: "nl-NL" },
  NO: { code: "NO", name: "Norway", locale: "nb-NO" },
  PL: { code: "PL", name: "Poland", locale: "pl-PL" },
  PT: { code: "PT", name: "Portugal", locale: "pt-PT" },
  RO: { code: "RO", name: "Romania", locale: "ro-RO" },
  RS: { code: "RS", name: "Serbia", locale: "sr-RS" },
  SE: { code: "SE", name: "Sweden", locale: "sv-SE" },
  SI: { code: "SI", name: "Slovenia", locale: "sl-SI" },
  SK: { code: "SK", name: "Slovakia", locale: "sk-SK" },
  UK: {
    code: "UK",
    name: "United Kingdom",
    locale: "en-UK",
    hreflang: "en-GB",
    flagCode: "GB",
  },
};

export const TENANT_SWITCH_TARGETS = {
  AT: "DE",
  DE: "AT",
};

